import { UserDTO } from '@/generated';
import { AccountType, LocalUser, Role } from '../models/user';
import { logout } from './auth';

export const setLocalUser = (user: LocalUser) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const deleteLocalUser = () => {
  localStorage.removeItem('user');
};

//TODO: Remove this
export const getLocalUser = (): LocalUser | null => {
  const localUserstring = localStorage.getItem('user');
  if (localUserstring) return JSON.parse(localUserstring);
  return null;
  //throw new Error('User not set.');
};

export const isLoggedIn = () => {
  return getLocalUser() !== null;
};

export const isAdminUser = (user?: UserDTO) => {
  //Try/catch, fix legacy login mobile issue
  try {
    return user?.roles.includes(Role.Admin);
  } catch (e) {
    logout();
    return false;
  }
};

export const isTrainerUser = (user?: UserDTO) => {
  //Try/catch, fix legacy login mobile issue
  try {
    return user?.roles.includes(Role.Trainer);
  } catch (e) {
    logout();
    return false;
  }
};

export const isPremiumUser = (user?: UserDTO) => {
  try {
    return user?.accountType === AccountType.premium;
  } catch (e) {
    return false;
  }
};
